import React, { useState } from "react";
import RenderButton from "../common/button";

const Headder = ({ onChange }) => {
  const [all, setall] = useState("btn btn-primary");
  const [log, setlog] = useState("btn btn-outline-dark");
  const [chip, setchip] = useState("btn btn-outline-dark");
  const [bark, setbark] = useState("btn btn-outline-dark");

  const [startDate, setStartDate] = useState(new Date());

  const handleonClick = ({ currentTarget: input }) => {
    if (input.value == 2) {
      disabledlabel();
      setlog("btn btn-primary");
    } else if (input.value == 0) {
      disabledlabel();
      setall("btn btn-primary");
    } else if (input.value == 1) {
      disabledlabel();
      setchip("btn btn-primary");
    } else if (input.value == 3) {
      disabledlabel();
      setbark("btn btn-primary");
    }
    onChange(input.value);
  };
  // const handleChange = (date) => {
  //     setStartDate(date)
  //     handleDateChange(date);
  // }

  const disabledlabel = () => {
    setall("btn btn-outline-dark");
    setlog("btn btn-outline-dark");
    setchip("btn btn-outline-dark");

    setbark("btn btn-outline-dark");
  };

  return (
  
      <div className="row">
        <div className="col-auto mb-1 px-0 ">
          <RenderButton
            label="ทั้งหมด"
            value="0"
            onClick={handleonClick}
            className={all}
          />
          <RenderButton
            value="2"
            label="ไม้ท่อน"
            onClick={handleonClick}
            className={log}
          />
          <RenderButton
            value="1"
            label="ไม้สับ"
            onClick={handleonClick}
            className={chip}
          />
          <RenderButton
            value="3"
            label="เปลือก"
            onClick={handleonClick}
            className={bark}
          />
        </div>
      </div>

  );
};

export default Headder;
